import { render, staticRenderFns } from "./DeclineTransferApproval.vue?vue&type=template&id=15285cc9&"
import script from "./DeclineTransferApproval.vue?vue&type=script&lang=js&"
export * from "./DeclineTransferApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports